module.exports = __webpack_public_path__ + "static/media/bear1.fd67849d.PNG";